// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chart-legend {
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.chart-legend__item {
  display: flex;
  flex-shrink: 0;
  gap: 4px;
  align-items: center;
}

.chart-legend__marker {
  flex-shrink: 0;
}

.chart-legend__marker--line {
  width: 10px;
  height: 3px;
  border-radius: 1px;
}

.chart-legend__marker--box {
  width: 10px;
  height: 10px;
}

.chart-legend__label {
  font-family: 'Arial', 'Helvetica', 'Sans-serif';
  font-weight: 400;
  font-size: 12px;
  line-height: normal;
  color: var(--text-primary);
  white-space: nowrap;
}
`, "",{"version":3,"sources":["webpack://./src/Widgets/FundSummaryWidget/components/FundChart/ChartLegend.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,cAAc;EACd,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,+CAA+C;EAC/C,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,0BAA0B;EAC1B,mBAAmB;AACrB","sourcesContent":[".chart-legend {\n  box-sizing: border-box;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n}\n\n.chart-legend__item {\n  display: flex;\n  flex-shrink: 0;\n  gap: 4px;\n  align-items: center;\n}\n\n.chart-legend__marker {\n  flex-shrink: 0;\n}\n\n.chart-legend__marker--line {\n  width: 10px;\n  height: 3px;\n  border-radius: 1px;\n}\n\n.chart-legend__marker--box {\n  width: 10px;\n  height: 10px;\n}\n\n.chart-legend__label {\n  font-family: 'Arial', 'Helvetica', 'Sans-serif';\n  font-weight: 400;\n  font-size: 12px;\n  line-height: normal;\n  color: var(--text-primary);\n  white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
